"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteChips = void 0;
const react_1 = __importStar(require("react"));
const Chip_1 = __importDefault(require("@material-ui/core/Chip"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const autocomplate_styles_1 = require("./autocomplate-styles");
const autocomplete_context_1 = require("./autocomplete-context");
function AutocompleteChips({ values, }) {
    const classes = autocomplate_styles_1.useStyles();
    const { labelMapper = (option) => option.name, onChange, } = react_1.useContext(autocomplete_context_1.AutocompleteContext);
    const handleDelete = event_callback_hook_1.useEventCallback((value) => {
        onChange(values.filter((v) => v !== value));
    });
    return (react_1.default.createElement("div", { className: classes.chips }, values.map((value) => (react_1.default.createElement(Chip_1.default, { key: value.id, label: labelMapper(value, 'FIELD'), className: classes.chip, variant: "outlined", size: "small", onDelete: () => handleDelete(value) })))));
}
exports.AutocompleteChips = AutocompleteChips;
//# sourceMappingURL=autocomplete-chips.js.map